// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__+fH+L","send":"logo_send__ilQly","tric":"logo_tric__BeIt8"};